import { useEffect } from 'react';

/**
 * Injects one or more JSON-LD structured data blocks into <head>.
 * Accepts a single object or an array. Blocks are keyed by `id` so they
 * are cleaned up when the component unmounts or the data changes.
 *
 * Structured data is the highest-leverage SEO/AEO/LLMO signal we can ship
 * from a client-rendered SPA — Google, Bing, ChatGPT, Perplexity, and Gemini
 * all consume JSON-LD as a first-class semantic prior.
 */
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    const blocks = Array.isArray(data) ? data : [data];

    const nodes = blocks.map((block, idx) => {
      const nodeId = `${id}-${idx}`;
      const existing = document.getElementById(nodeId);
      if (existing) existing.remove();
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.id = nodeId;
      s.textContent = JSON.stringify(block);
      document.head.appendChild(s);
      return nodeId;
    });

    return () => {
      nodes.forEach((n) => {
        const el = document.getElementById(n);
        if (el) el.remove();
      });
    };
  }, [id, data]);
}
